module.exports = __webpack_public_path__ + "static/media/money-bag.bce5af74.svg";